import { render } from "./GestioneCredenziali.vue?vue&type=template&id=78497bde&scoped=true"
import script from "./GestioneCredenziali.vue?vue&type=script&lang=js"
export * from "./GestioneCredenziali.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./GestioneCredenziali.vue?vue&type=style&index=1&id=78497bde&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78497bde"]])

export default __exports__